module.exports = __webpack_public_path__ + "static/img/NcToyotaHotlead2025.17c0abb.png";